export const alphaNumMask = {
  mask: /^[[:alnum:]\s]*$/
}

export const alphaMask = {
  mask: /^[a-zA-Z\s]*$/
}
